/*eslint-disable*/

import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ReactSelect from "react-select";
import { makeStyles } from "@material-ui/core/styles";

import {
  blendColors,
  defaultFont,
  grayColor,
  whiteColor,
} from "../../assets/jss/material-dashboard-pro-react";
const customReactSelectStyles = (isMulti) => ({
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + " !important",
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "1.42857",
    letterSpacing: "unset",
    transformOrigin: "top left",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
    "&:not(.collapse)": {
      transform: isMulti ? "translate(1px, 26px)" : "translate(1px, 24px)",
    },
    "&.collapse": {
      transform: "translate(1px, 1.5px) scale(0.75)",
    },
    position: "relative",
  },
});

export default function CustomReactSelect(props) {
  const {
    title,
    isMulti,
    isClearable,
    closeMenuOnSelect,
    hideSelectedOptions,
    options,
    value,
    onChange,
    customStyles,
    baseColor,
    optionVerticalPadding,
    style,
    isDisabled,
    isSearchable,
    isOptionDisabled,
    placeholder,
    formatOptionLabel,
  } = props;

  const useStyles = makeStyles(customReactSelectStyles(isMulti));
  const classes = useStyles();

  const [focused, setFocused] = useState(false);
  const [internalValue, setInternalValue] = useState(isMulti ? [] : null);

  // Use internal value if no external value is provided
  const currentValue = value !== undefined ? value : internalValue;

  // Handle value changes
  const handleChange = (newValue) => {
    if (value === undefined) {
      // If no external value prop, manage internally
      setInternalValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  const selectStyles = customStyles || {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "0",
      borderWidth: "0 0 1px 0",
      borderColor: state.isFocused ? baseColor : provided.borderColor,
      marginTop: isMulti ? "-6px" : "-8px",
      boxShadow: "none",
      "&:hover": {
        borderColor: baseColor,
      },
      zIndex: "1",
    }),
    option: (provided, state) => ({
      ...provided,
      paddingTop: optionVerticalPadding,
      paddingBottom: optionVerticalPadding,
      color: grayColor[14],
      backgroundColor: state.isSelected
        ? blendColors(whiteColor, baseColor, 0.6)
        : state.isFocused
          ? blendColors(whiteColor, baseColor, 0.8)
          : whiteColor,
      "&:active": {
        backgroundColor: blendColors(whiteColor, baseColor, 0.7),
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "2px",
      // zIndex: isMulti ? "9999" : provided.zIndex,
      zIndex: "3",
    }),
    singleValue: (provided) => ({
      ...provided,
      marginTop: "4px",
      color: grayColor[14],
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: blendColors(whiteColor, baseColor, 0.8), // Background color of selected tags
    }),
  };

  return (
    <div style={style}>
      {title && (
        <div
          className={cx({
            [classes.labelRoot]: true,
            ["collapse"]:
              focused ||
              (isMulti
                ? currentValue && currentValue.length > 0
                : currentValue),
          })}
          style={{ zIndex: 2, position: "relative", pointerEvents: "none" }}
        >
          {title}
        </div>
      )}
      <div style={{ zIndex: 1 }}>
        <ReactSelect
          isMulti={isMulti}
          isClearable={isClearable}
          isSearchable={isSearchable}
          closeMenuOnSelect={closeMenuOnSelect}
          hideSelectedOptions={hideSelectedOptions}
          options={options}
          value={currentValue}
          onChange={handleChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder || ""}
          isDisabled={isDisabled}
          isOptionDisabled={isOptionDisabled}
          formatOptionLabel={formatOptionLabel}
          styles={selectStyles}
        />
      </div>
    </div>
  );
}

CustomReactSelect.defaultProps = {
  baseColor: grayColor[6],
  optionVerticalPadding: "4px",
};

CustomReactSelect.propTypes = {
  title: PropTypes.string,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  hideSelectedOptions: PropTypes.bool,
  options: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  customStyles: PropTypes.object,
  baseColor: PropTypes.string,
  optionVerticalPadding: PropTypes.string,
  style: PropTypes.object,
  isDisabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isOptionDisabled: PropTypes.func,
  placeholder: PropTypes.string,
  formatOptionLabel: PropTypes.func,
};
